import { XktContext } from "@/Context/XktContext/XktContextProvider";
import { ToggleGroup, ToggleGroupItem } from "@/components/ui/toggle-group";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import { Hand, Rotate3D } from "lucide-react";
import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

enum CameraControls {
    MOUSE_PAN = 18,
    MOUSE_ROTATE = 19,
}
enum Inputs {
    MOUSE_LEFT_BUTTON = 260,
    MOUSE_RIGHT_BUTTON = 262,
    KEY_SHIFT = 16,
}

const OrbitPanToggle = () => {
    const { state } = useContext(XktContext);
    const [leftClick, setLeftClick] = useState("orbit");
    const { t } = useTranslation();
    useEffect(() => {
        if (!state.viewer) return;
        const cameraControl = state.viewer.cameraControl;
        if (!cameraControl) return;
        const keyMap = cameraControl.keyMap;
        if (leftClick == "orbit") {
            keyMap[CameraControls.MOUSE_PAN] = [
                [Inputs.MOUSE_LEFT_BUTTON, Inputs.KEY_SHIFT],
                Inputs.MOUSE_RIGHT_BUTTON,
            ] as unknown as number;
            keyMap[CameraControls.MOUSE_ROTATE] = [Inputs.MOUSE_LEFT_BUTTON] as unknown as number;
        } else {
            keyMap[CameraControls.MOUSE_PAN] = [Inputs.MOUSE_LEFT_BUTTON] as unknown as number;
            keyMap[CameraControls.MOUSE_ROTATE] = [] as unknown as number;
        }

        cameraControl.keyMap = keyMap;
    }, [leftClick, state.viewer]);
    return (
        <ToggleGroup
            type="single"
            value={leftClick}
            onValueChange={(value) => {
                if (!value) return;
                // value =
                //     leftClick === "orbit"
                //         ? "pan"
                //         : "orbit";
                setLeftClick(value);
            }}
        >
            <Tooltip>
                <TooltipTrigger asChild>
                    <span className="inline-flex">
                        <ToggleGroupItem value="orbit" aria-label={t("orbitAriaLabel")}>
                            <Rotate3D className="h-4 w-4" />
                        </ToggleGroupItem>
                    </span>
                </TooltipTrigger>
                <TooltipContent>
                    <p>{t("orbit")}</p>
                </TooltipContent>
            </Tooltip>
            <Tooltip>
                <TooltipTrigger asChild>
                    <span className="inline-flex">
                        <ToggleGroupItem value="pan" aria-label={t("panAriaLabel")}>
                            <Hand className="h-4 w-4" />
                        </ToggleGroupItem>
                    </span>
                </TooltipTrigger>
                <TooltipContent>
                    <p>{t("pan")}</p>
                </TooltipContent>
            </Tooltip>
        </ToggleGroup>
    );
};

export default OrbitPanToggle;
